import { cx } from '@linaria/core';
import { useRef, useEffect } from 'react';
import { PM2LightBulbIcon } from '@ui/kit';
import { useIntersectionObserver, CSSRefTransition } from '@utils/react';
import { hint, revealTransitionDurationMs, badge, label, text } from './atom.hint.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

let isScrolling = false;
function Hint(props) {
  const ref = useRef(null);
  const isIntersecting = useIntersectionObserver(ref, {
    once: true
  });
  useEffect(() => {
    const isEntering = ref.current?.parentElement?.className.includes("-enter");
    if (isEntering && !isScrolling) {
      ref.current?.scrollIntoView({
        block: "nearest",
        behavior: "smooth"
      });
      isScrolling = true;
      setTimeout(() => {
        isScrolling = false;
      }, 500);
    }
  }, []);
  const isVisible = isIntersecting || !props.withAnimation;
  return /*#__PURE__*/jsx(CSSRefTransition, {
    in: isVisible,
    nodeRef: ref,
    classNames: hint,
    timeout: {
      enter: revealTransitionDurationMs,
      exit: 0
    },
    children: ref => /*#__PURE__*/jsxs("div", {
      ref: ref,
      className: cx(hint, isVisible && "visible"),
      "data-highlighted": props.highlighted,
      children: [/*#__PURE__*/jsx("div", {
        className: badge,
        children: /*#__PURE__*/jsx(PM2LightBulbIcon, {
          height: 22
        })
      }), /*#__PURE__*/jsxs("span", {
        className: label,
        children: ["Hint ", props.index + 1, ":"]
      }), /*#__PURE__*/jsx("span", {
        className: text,
        children: props.text
      })]
    })
  });
}

export { Hint };
//# sourceMappingURL=atom.hint.js.map
